import { RouterSimpleState } from '@neptune/shared/routing-domain';

export function rejectActivation(stateToRedirect: RouterSimpleState): Promise<never> {
  return Promise.reject({ redirect: stateToRedirect });
}
